import { Routes } from '@angular/router';
import { isLoggedInNonAnon } from './common/authz-route-guard';


export const routes: Routes = [
  { path: '', loadComponent: () => import('./pricing/pricing.component').then(c => c.PricingComponent)},
  { path: 'events', canActivate: [isLoggedInNonAnon], loadComponent: () => import('./events/events.component').then(c => c.EventsComponent)},
  { path: 'login', loadComponent: () => import('./login/login.component').then(c => c.LoginComponent)},
  { path: 'buy', canActivate: [isLoggedInNonAnon], loadComponent: () => import('./buy/buy.component').then(c => c.BuyComponent)},
  { path: 'error', loadComponent: () => import('./error/error.component').then(c => c.ErrorComponent), data: {title: 'Error'}},
  { path: ':eventKey', loadChildren: () => import('./event/event.routes').then(m => m.routes) },
  { path: '**', redirectTo: 'error'},
];
